import React from "react";
import { makeStyles } from '@mui/styles';
import classnames from "classnames";

const useStyles = makeStyles(theme => ({
  message: {
    position: "relative",
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    maxWidth: "70%"
  },
  customer: {
    borderTopRightRadius: 0,
    marginLeft: "auto",
    backgroundColor: "#FFECC4",
    // backgroundColor: "#ea1d25", //TODO: Change this to a theme custom variable or palette
    color: "#333333"
  },
  bot: {
    marginRight: "auto",
    // border: '1px solid #ea1d25', //TODO: Change this to a theme custom variable or palette
    border: "1px solid #333333",
    backgroundColor: "white",
    borderTopLeftRadius: 0,
    color: "#333333"
  }
}));

function Bubble({ children, sender }) {
  const classes = useStyles();

  let bubbleClassName;
  if (typeof sender === "string" && sender.toLowerCase() === "customer") {
    bubbleClassName = classes.customer;
  } else {
    bubbleClassName = classes.bot;
  }

  return <div className={classnames(classes.message, bubbleClassName)}>{children}</div>;
}

export default Bubble;
